import { useState } from 'react'
import { IconeInfo } from '../icones'
import { FolhaInferior } from './FolhaInferior'
import { MarcaVerticalLab } from './MarcaVerticalLab'

/**
 * Conteúdo da página Sobre. É AQUI que se fala do sistema e da equipe —
 * editar estas duas constantes é editar a página inteira, sem mexer em JSX.
 */
const DESCRICAO_SISTEMA =
  'Vertical Lab é um laboratório didático 3D de salvamento terrestre, ' +
  'para treino de bombeiros e estudantes da área de emergência. Hoje reúne o table top, ' +
  'onde o instrutor monta livremente a ocorrência num ambiente 3D que o aluno manipula ' +
  'diretamente. As técnicas com escada, viatura e cordas, o trabalho em altura e o corte ' +
  'de árvore estão em desenvolvimento.'

/** De onde o projeto vem. Mantém o crédito junto da descrição, não escondido no código. */
const ORIGEM_SISTEMA =
  'O Vertical Lab é uma variação do RESCUE-LAB, criada por Marco Guerra. A base 3D ' +
  '(ambiente de trabalho, table top e vítima articulada) vem do RESCUE-LAB; o conteúdo ' +
  'deste projeto é de salvamento terrestre.'

interface MembroEquipe {
  nome: string
  papel: string
}

/** Um item por pessoa. Adicionar alguém na equipe é acrescentar uma linha aqui. */
const EQUIPE: readonly MembroEquipe[] = [
  { nome: 'Marco Guerra', papel: 'Desenvolvimento' },
]

export function Sobre() {
  const [aberta, setAberta] = useState(false)

  return (
    <>
      <button
        type="button"
        className="tema-no-topo"
        onClick={() => setAberta(true)}
        aria-label="Sobre o Vertical Lab"
        title="Sobre o Vertical Lab"
      >
        <IconeInfo tamanho={18} />
      </button>

      <FolhaInferior
        aberta={aberta}
        titulo="Sobre o Vertical Lab"
        aoFechar={() => setAberta(false)}
        fracaoAltura={0.7}
        className="sobre"
      >
        <MarcaVerticalLab variante="logo" className="sobre__marca" />

        <section className="sobre__secao">
          <h3 className="sobre__titulo-secao">O sistema</h3>
          <p>{DESCRICAO_SISTEMA}</p>
          <p className="sobre__tecnologias">React · TypeScript · Three.js · React Three Fiber</p>
        </section>

        <section className="sobre__secao">
          <h3 className="sobre__titulo-secao">Origem</h3>
          <p>{ORIGEM_SISTEMA}</p>
        </section>

        <section className="sobre__secao">
          <h3 className="sobre__titulo-secao">A equipe</h3>
          <ul className="sobre__equipe">
            {EQUIPE.map((membro) => (
              <li key={membro.nome}>
                <strong>{membro.nome}</strong>
                <span>{membro.papel}</span>
              </li>
            ))}
          </ul>
        </section>

        <p className="sobre__aviso">
          Apoio a treinamento. Não substitui doutrina, instrutor nem protocolo operacional.
        </p>

        <p className="sobre__direitos">
          © 2026 Marco Guerra. Todos os direitos reservados. Software proprietário: não é permitido copiar, hospedar,
          modificar ou redistribuir o código, os cenários ou os textos sem autorização escrita.
        </p>

        <p className="sobre__creditos">
          Desenvolvido por{' '}
          <a
            href="https://marcoguerra.dev.br"
            target="_blank"
            rel="noreferrer"
            className="marca-digital-bricks"
          >
            <img
              src="/logo-digital-bricks.png"
              alt=""
              aria-hidden="true"
              className="marca-digital-bricks__logo"
            />
            <span>Marco Guerra</span>
          </a>
        </p>
      </FolhaInferior>
    </>
  )
}
